<script lang="ts">let { size = "20" } = $props();
</script>

<svg height={size} style="fill: currentColor" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
	<g>
		<path
			d="m6.628 4.536-1.73 4.04h10.615l-7.65-4.464a.863.863 0 0 0-1.235.424m5.226 6.744v2.663h-1.296V11.28c0-.752-.587-1.366-1.316-1.366h-6.43c-.725 0-1.312.614-1.312 1.366v2.663h.612c1.062 0 1.955.868 1.975 1.964.026 1.133-.852 2.064-1.939 2.064H1.5v2.663c0 .752.587 1.366 1.317 1.366h6.43c.724 0 1.316-.609 1.316-1.366v-5.347h1.297v5.347c0 .752.586 1.366 1.316 1.366h9.018c.724 0 1.316-.609 1.316-1.366V11.28c0-.752-.587-1.366-1.316-1.366h-9.028c-.725 0-1.312.614-1.312 1.366m4.292 1.826.914.948-.914.953-.913-.948zm3.66 5.696-.914-.947.913-.948.914.948zm-3.66 0-.913-.947 4.577-4.749.914.948zm4.312-10.228-9.165-6.416c-.455-.317-1.072-.132-1.297.387L9.562 3.56l8.59 5.013z"
		/>
	</g>
</svg>
